import * as types from '../mutation-types';
import { unionState, toDateTimeString } from '../helpers';

const state = () => ({
    coupons: [],
});

const actions = {
    fetchAll({ commit }) {
        return axios.get('/api/coupons').then(response => {
            commit(types.STORE_COUPONS, response.data);

            return response.data;
        });
    },

    fetch({ commit }, { id }) {
        return axios.get(`/api/coupons/${id}`).then(response => {
            commit(types.STORE_ONE_COUPON, response.data);

            return response.data;
        });
    },

    create({ commit }, { code, discount, active, endDate }) {
        const formData = new FormData();
        formData.append('code', code);
        formData.append('discount', discount);
        formData.append('active', active);
        formData.append('endDate', endDate);

        return axios.post(`/api/coupons`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            commit(types.STORE_ONE_COUPON, response.data);

            return response.data;
        });
    },

    update({ commit }, {id, code, discount, endDate }) {
        const formData = new FormData();
        formData.append('code', code);
        formData.append('discount', discount);
        formData.append('endDate', endDate);

        formData.append('_method', 'PUT');

        return axios.post(`/api/coupons/${id}/update`, formData, formData ,{
            headers: {
                'Content-Type': 'multipart/params'
            }
        }).then(response => {
            commit(types.STORE_ONE_COUPON, response.data);

            return response.data;
        });
    },

    active({commit} , {couponId}){
		return axios.put(`/api/coupons/${couponId}/setactive`, {
			couponId: couponId
		}).then(response => {
			commit(types.SET_ACTIVE, couponId);

			return response.data;
		});
	},

    delete({ commit }, { couponId }) {
        return axios.delete(`/api/coupons/${couponId}`).then(response => {
            commit(types.DELETE_ONE_COUPON, couponId);
        });
    },
};
const mutations = {
    [types.STORE_COUPONS](state, coupons) {
        state.coupons = unionState(state.coupons, coupons);
    },

    [types.STORE_ONE_COUPON](state, coupons) {
        state.coupons = unionState(state.coupons, [coupons]);
    },

    [types.DELETE_ONE_COUPON](state, couponId) {
        // const coupons = state.coupons.find(t => t.id === couponId);
        // state.coupons = unionState(state.coupons , [coupon])
        state.categories = state.categories.find(p => p.id !== couponId);
    },
    [types.SET_ACTIVE](state, id) {
		const coupons = state.coupons.find(c => c.id === id);
		coupons.active = !coupons.active;
	},
};

const getters = {
    getById: state => id => state.coupons.find(n => n.id === id),
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
